// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.css
// module id = 1058
// module chunks = 24